import { Text } from '@medly-components/core';
import Styled from 'components/common/Styled';
import type { FC } from 'react';
import royalBlue from 'theme/colors/royalBlue';
import type { CaptureInfoFormHeaderProps } from './types';

export const CaptureInfoFormHeader: FC<CaptureInfoFormHeaderProps> = ({ blueHeader, mediumHeader }) => {
    return (
        <Styled.FlexBox direction="column" rowGap="0.2rem">
            {blueHeader && (
                <Text textColor={royalBlue[500]} textVariant="body1" textWeight="Light">
                    {blueHeader}
                </Text>
            )}
            {mediumHeader && (
                <Text textVariant="h2" textWeight="Light">
                    {mediumHeader}
                </Text>
            )}
        </Styled.FlexBox>
    );
};
